import { calculateLineItemTotal, type OrderItem } from "../orderCommons.js";

/** Order total in minor units with VAT rounded per item, delivery and discount line. */
export const calculateTotal = (params: {
  orderItems: Pick<OrderItem, "price" | "quantity">[];
  deliveryCharge: number;
  discountAmount: number;
  vatPercentage: number;
}): number => {
  const total = params.orderItems
    .concat([
      { price: params.deliveryCharge, quantity: 1 },
      { price: -params.discountAmount, quantity: 1 },
    ])
    .map((orderItem) => calculateLineItemTotal(orderItem, params.vatPercentage))
    .reduce((acc, lineItemTotal) => acc + lineItemTotal, 0);

  return total < 0 ? 0 : total;
};
